var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c(
        "Drawer",
        {
          attrs: {
            title: "客户详情",
            width: "1000",
            scrollable: true,
            "mask-closable": false,
            closable: false,
            styles: _vm.styles
          },
          model: {
            value: _vm.showUserDetails,
            callback: function($$v) {
              _vm.showUserDetails = $$v
            },
            expression: "showUserDetails"
          }
        },
        [
          _vm.showEditUserInfo
            ? _c(
                "div",
                [
                  _c("div", { staticClass: "user_info_wrap" }, [
                    _c("span", { staticClass: "user_info_title" }, [
                      _vm._v("基本信息")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c(
                          "Button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.handleSubmit("userInfoForm")
                              }
                            }
                          },
                          [_vm._v("保存")]
                        ),
                        _vm._v(" "),
                        _c(
                          "Button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.handleReset("userInfoForm")
                              }
                            }
                          },
                          [_vm._v("取消")]
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "Form",
                    {
                      ref: "userInfoForm",
                      attrs: {
                        model: _vm.userInfoForm,
                        rules: _vm.userInfoFormRule,
                        "label-width": 80
                      }
                    },
                    [
                      _c(
                        "Row",
                        [
                          _c(
                            "Col",
                            { attrs: { span: "8" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "姓名", prop: "name" } },
                                [
                                  _c("Input", {
                                    attrs: { placeholder: "请输入姓名" },
                                    model: {
                                      value: _vm.userInfoForm.name,
                                      callback: function($$v) {
                                        _vm.$set(_vm.userInfoForm, "name", $$v)
                                      },
                                      expression: "userInfoForm.name"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "Col",
                            { attrs: { span: "8" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "身份证" } },
                                [
                                  _c("Input", {
                                    attrs: {
                                      placeholder: "请输入身份证",
                                      maxlength: 18
                                    },
                                    on: { "on-blur": _vm.idCardBlur },
                                    model: {
                                      value: _vm.userInfoForm.id_card,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.userInfoForm,
                                          "id_card",
                                          $$v
                                        )
                                      },
                                      expression: "userInfoForm.id_card"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "Col",
                            { attrs: { span: "8" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "出生日期" } },
                                [
                                  _c("DatePicker", {
                                    attrs: {
                                      type: "date",
                                      placeholder: "请选择出生日期"
                                    },
                                    model: {
                                      value: _vm.userInfoForm.birthday,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.userInfoForm,
                                          "birthday",
                                          $$v
                                        )
                                      },
                                      expression: "userInfoForm.birthday"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "Col",
                            { attrs: { span: "8" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "手机", prop: "phone" } },
                                [
                                  _c("Input", {
                                    attrs: {
                                      placeholder: "请输入手机",
                                      disabled: _vm.disabled
                                    },
                                    model: {
                                      value: _vm.userInfoForm.phone,
                                      callback: function($$v) {
                                        _vm.$set(_vm.userInfoForm, "phone", $$v)
                                      },
                                      expression: "userInfoForm.phone"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "Col",
                            { attrs: { span: "8" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "性别" } },
                                [
                                  _c(
                                    "RadioGroup",
                                    {
                                      model: {
                                        value: _vm.userInfoForm.sex,
                                        callback: function($$v) {
                                          _vm.$set(_vm.userInfoForm, "sex", $$v)
                                        },
                                        expression: "userInfoForm.sex"
                                      }
                                    },
                                    [
                                      _c("Radio", { attrs: { label: "1" } }, [
                                        _vm._v("男")
                                      ]),
                                      _vm._v(" "),
                                      _c("Radio", { attrs: { label: "2" } }, [
                                        _vm._v("女")
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "Col",
                            { attrs: { span: "8" } },
                            [
                              _c(
                                "FormItem",
                                {
                                  attrs: {
                                    label: "咨询日期",
                                    prop: "consult_time"
                                  }
                                },
                                [
                                  _c("DatePicker", {
                                    attrs: {
                                      type: "date",
                                      placeholder: "请选择咨询日期"
                                    },
                                    model: {
                                      value: _vm.userInfoForm.consult_time,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.userInfoForm,
                                          "consult_time",
                                          $$v
                                        )
                                      },
                                      expression: "userInfoForm.consult_time"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "Col",
                            { attrs: { span: "24" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "所在区域" } },
                                [
                                  _c(
                                    "Select",
                                    {
                                      staticStyle: { width: "15%" },
                                      attrs: { placeholder: "请选择省" },
                                      on: { "on-change": _vm.changeProvince },
                                      model: {
                                        value: _vm.userInfoForm.province_id,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.userInfoForm,
                                            "province_id",
                                            $$v
                                          )
                                        },
                                        expression: "userInfoForm.province_id"
                                      }
                                    },
                                    _vm._l(_vm.province, function(item) {
                                      return _c(
                                        "Option",
                                        {
                                          key: item.id,
                                          attrs: { value: item.id }
                                        },
                                        [_vm._v(_vm._s(item.name))]
                                      )
                                    }),
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "Select",
                                    {
                                      staticStyle: { width: "15%" },
                                      attrs: { placeholder: "请选择市" },
                                      on: { "on-change": _vm.changeCity },
                                      model: {
                                        value: _vm.userInfoForm.city_id,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.userInfoForm,
                                            "city_id",
                                            $$v
                                          )
                                        },
                                        expression: "userInfoForm.city_id"
                                      }
                                    },
                                    _vm._l(_vm.city, function(item) {
                                      return _c(
                                        "Option",
                                        {
                                          key: item.id,
                                          attrs: { value: item.id }
                                        },
                                        [_vm._v(_vm._s(item.name))]
                                      )
                                    }),
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "Select",
                                    {
                                      staticStyle: { width: "15%" },
                                      attrs: { placeholder: "请选择区" },
                                      model: {
                                        value: _vm.userInfoForm.area_id,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.userInfoForm,
                                            "area_id",
                                            $$v
                                          )
                                        },
                                        expression: "userInfoForm.area_id"
                                      }
                                    },
                                    _vm._l(_vm.area, function(item) {
                                      return _c(
                                        "Option",
                                        {
                                          key: item.id,
                                          attrs: { value: item.id }
                                        },
                                        [_vm._v(_vm._s(item.name))]
                                      )
                                    }),
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("Input", {
                                    staticStyle: { width: "50%" },
                                    attrs: { placeholder: "请输入详细地址" },
                                    model: {
                                      value: _vm.userInfoForm.address,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.userInfoForm,
                                          "address",
                                          $$v
                                        )
                                      },
                                      expression: "userInfoForm.address"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "Col",
                            { attrs: { span: "24" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "备注", prop: "remark" } },
                                [
                                  _c("Input", {
                                    attrs: {
                                      type: "textarea",
                                      autosize: { minRows: 2, maxRows: 5 },
                                      placeholder: "200字（含）以内"
                                    },
                                    model: {
                                      value: _vm.userInfoForm.remark,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.userInfoForm,
                                          "remark",
                                          $$v
                                        )
                                      },
                                      expression: "userInfoForm.remark"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "user_info_wrap" }, [
                        _c("span", { staticClass: "user_info_title" }, [
                          _vm._v("详细信息")
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "Row",
                        [
                          _c(
                            "Col",
                            { attrs: { span: "8" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "民族" } },
                                [
                                  _c("Input", {
                                    attrs: { placeholder: "请输入民族" },
                                    model: {
                                      value: _vm.userInfoForm.nation,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.userInfoForm,
                                          "nation",
                                          $$v
                                        )
                                      },
                                      expression: "userInfoForm.nation"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "Col",
                            { attrs: { span: "8" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "籍贯" } },
                                [
                                  _c("Input", {
                                    attrs: { placeholder: "请输入籍贯" },
                                    model: {
                                      value: _vm.userInfoForm.birth_place,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.userInfoForm,
                                          "birth_place",
                                          $$v
                                        )
                                      },
                                      expression: "userInfoForm.birth_place"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "Col",
                            { attrs: { span: "8" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "学历" } },
                                [
                                  _c("Input", {
                                    attrs: { placeholder: "请输入学历" },
                                    model: {
                                      value: _vm.userInfoForm.education,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.userInfoForm,
                                          "education",
                                          $$v
                                        )
                                      },
                                      expression: "userInfoForm.education"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "Col",
                            { attrs: { span: "8" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "身高" } },
                                [
                                  _c("Input", {
                                    attrs: { placeholder: "请输入身高" },
                                    model: {
                                      value: _vm.userInfoForm.height,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.userInfoForm,
                                          "height",
                                          $$v
                                        )
                                      },
                                      expression: "userInfoForm.height"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "Col",
                            { attrs: { span: "8" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "体重" } },
                                [
                                  _c("Input", {
                                    attrs: { placeholder: "请输入体重" },
                                    model: {
                                      value: _vm.userInfoForm.weight,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.userInfoForm,
                                          "weight",
                                          $$v
                                        )
                                      },
                                      expression: "userInfoForm.weight"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "Col",
                            { attrs: { span: "8" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "职业" } },
                                [
                                  _c(
                                    "Select",
                                    {
                                      staticStyle: {},
                                      attrs: { placeholder: "请选择职业" },
                                      model: {
                                        value: _vm.userInfoForm.job,
                                        callback: function($$v) {
                                          _vm.$set(_vm.userInfoForm, "job", $$v)
                                        },
                                        expression: "userInfoForm.job"
                                      }
                                    },
                                    _vm._l(_vm.baseData.industry, function(
                                      item
                                    ) {
                                      return _c(
                                        "Option",
                                        {
                                          key: item.id,
                                          attrs: { value: item.id }
                                        },
                                        [_vm._v(_vm._s(item.name))]
                                      )
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.showEditUserInfo
            ? _c(
                "div",
                [
                  _c("div", { staticClass: "user_info_wrap" }, [
                    _c("span", { staticClass: "user_info_title" }, [
                      _vm._v("基本信息")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c(
                          "Button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.editUserInfo }
                          },
                          [_vm._v("编辑")]
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "Row",
                    [
                      _c("Col", { attrs: { span: "8" } }, [
                        _c("div", { staticClass: "user_info_text_wrap" }, [
                          _c("span", [_vm._v("姓名：")]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.userInfoFormBackup.name))
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("Col", { attrs: { span: "8" } }, [
                        _c("div", { staticClass: "user_info_text_wrap" }, [
                          _c("span", [_vm._v("身份证：")]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.userInfoFormBackup.id_card))
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("Col", { attrs: { span: "8" } }, [
                        _c("div", { staticClass: "user_info_text_wrap" }, [
                          _c("span", [_vm._v("出生日期：")]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.userInfoFormBackup.birthday))
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("Col", { attrs: { span: "8" } }, [
                        _c(
                          "div",
                          { staticClass: "user_info_text_wrap" },
                          [
                            _c("span", [_vm._v("手机：")]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.userInfoFormBackup.phone))
                            ]),
                            _vm._v(" "),
                            _c("Button", {
                              staticClass: "item",
                              attrs: { icon: "ios-eye-outline", type: "text" },
                              on: { click: _vm.getphone }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("Col", { attrs: { span: "8" } }, [
                        _c("div", { staticClass: "user_info_text_wrap" }, [
                          _c("span", [_vm._v("性别：")]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.userInfoFormBackup.sex_text))
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("Col", { attrs: { span: "8" } }, [
                        _c("div", { staticClass: "user_info_text_wrap" }, [
                          _c("span", [_vm._v("咨询日期：")]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.userInfoFormBackup.consult_time))
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("Col", { attrs: { span: "24" } }, [
                        _c("div", { staticClass: "user_info_text_wrap" }, [
                          _c("span", [_vm._v("所在区域：")]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.userInfoFormBackup.region +
                                  _vm.userInfoForm.address
                              )
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("Col", { attrs: { span: "24" } }, [
                        _c("div", { staticClass: "user_info_text_wrap" }, [
                          _c("span", [_vm._v("备注：")]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.userInfoFormBackup.remark))
                          ])
                        ])
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "user_info_wrap" }, [
                    _c("span", { staticClass: "user_info_title" }, [
                      _vm._v("详细信息")
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "Row",
                    [
                      _c("Col", { attrs: { span: "8" } }, [
                        _c("div", { staticClass: "user_info_text_wrap" }, [
                          _c("span", [_vm._v("民族：")]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.userInfoFormBackup.nation))
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("Col", { attrs: { span: "8" } }, [
                        _c("div", { staticClass: "user_info_text_wrap" }, [
                          _c("span", [_vm._v("籍贯：")]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.userInfoFormBackup.birth_place))
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("Col", { attrs: { span: "8" } }, [
                        _c("div", { staticClass: "user_info_text_wrap" }, [
                          _c("span", [_vm._v("学历：")]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.userInfoFormBackup.education))
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("Col", { attrs: { span: "8" } }, [
                        _c("div", { staticClass: "user_info_text_wrap" }, [
                          _c("span", [_vm._v("身高：")]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.userInfoFormBackup.height != ""
                                  ? _vm.userInfoFormBackup.height + "CM"
                                  : ""
                              )
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("Col", { attrs: { span: "8" } }, [
                        _c("div", { staticClass: "user_info_text_wrap" }, [
                          _c("span", [_vm._v("体重：")]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.userInfoFormBackup.weight != ""
                                  ? _vm.userInfoFormBackup.weight + "KG"
                                  : ""
                              )
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("Col", { attrs: { span: "8" } }, [
                        _c("div", { staticClass: "user_info_text_wrap" }, [
                          _c("span", [_vm._v("职业：")]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.userInfoFormBackup.job))
                          ])
                        ])
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "user_info_wrap" }, [
            _c("span", { staticClass: "user_info_title" }, [
              _vm._v("录入信息列表")
            ]),
            _vm._v(" "),
            _c(
              "div",
              [
                _c(
                  "Button",
                  { attrs: { type: "primary" }, on: { click: _vm.addChannel } },
                  [_vm._v("添加渠道")]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("Table", {
            attrs: {
              stripe: "",
              border: "",
              columns: _vm.tabEntryColumns,
              data: _vm.tabEntryData
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "user_info_wrap" }, [
            _c("span", { staticClass: "user_info_title" }, [
              _vm._v("门店信息列表")
            ]),
            _vm._v(" "),
            _c(
              "div",
              [
                _c(
                  "Button",
                  { attrs: { type: "primary" }, on: { click: _vm.addStores } },
                  [_vm._v("添加跟进门店")]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("Table", {
            attrs: {
              stripe: "",
              border: "",
              columns: _vm.tabStoresColumns,
              data: _vm.tabStoresData
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "user_info_wrap" }, [
            _c("span", { staticClass: "user_info_title" }, [
              _vm._v("产妇信息列表")
            ]),
            _vm._v(" "),
            _c(
              "div",
              [
                _vm.tabMaternalData.length == 0
                  ? _c(
                      "Button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.addMaternal }
                      },
                      [_vm._v("添加产妇信息")]
                    )
                  : _vm._e()
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("Table", {
            attrs: {
              stripe: "",
              border: "",
              columns: _vm.tabMaternalColumns,
              data: _vm.tabMaternalData
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "user_info_wrap" }, [
            _c("span", { staticClass: "user_info_title" }, [
              _vm._v("跟进人列表")
            ]),
            _vm._v(" "),
            _c(
              "div",
              [
                _c(
                  "Button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.addWithPeople }
                  },
                  [_vm._v("添加跟进人")]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("Table", {
            attrs: {
              stripe: "",
              border: "",
              columns: _vm.tabWithPeopleColumns,
              data: _vm.tabWithPeopleData
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "demo-drawer-footer" },
            [
              _c(
                "Button",
                { attrs: { type: "primary" }, on: { click: _vm.isEditorOk } },
                [_vm._v("收起")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Modal",
        {
          attrs: {
            closable: false,
            "mask-closable": false,
            "class-name": "vertical-center-modal"
          },
          model: {
            value: _vm.showAddChannel,
            callback: function($$v) {
              _vm.showAddChannel = $$v
            },
            expression: "showAddChannel"
          }
        },
        [
          _c(
            "p",
            {
              staticClass: "modal_title",
              attrs: { slot: "header" },
              slot: "header"
            },
            [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.isModalTitle == 1
                      ? "添加渠道"
                      : _vm.isModalTitle == 2
                      ? "编辑渠道"
                      : ""
                  )
                )
              ])
            ]
          ),
          _vm._v(" "),
          _vm.isModalTitle == 1
            ? _c("Alert", { attrs: { type: "error" } }, [
                _vm._v(
                  "*增加渠道会让您成为第二录入人，可查看该客户所有回访信息"
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "Form",
            {
              ref: "addChannelForm",
              attrs: {
                model: _vm.addChannelForm,
                rules: _vm.addChannelFormRule,
                "label-width": 80
              }
            },
            [
              _c(
                "FormItem",
                { attrs: { label: "渠道", prop: "department_id" } },
                [
                  _c(
                    "Select",
                    {
                      staticStyle: { width: "90%" },
                      attrs: { placeholder: "请选择部门" },
                      on: { "on-change": _vm.changeAddChannel },
                      model: {
                        value: _vm.addChannelForm.department_id,
                        callback: function($$v) {
                          _vm.$set(_vm.addChannelForm, "department_id", $$v)
                        },
                        expression: "addChannelForm.department_id"
                      }
                    },
                    _vm._l(_vm.departmentList, function(item) {
                      return _c(
                        "Option",
                        { key: item.id, attrs: { value: item.id } },
                        [_vm._v(_vm._s(item.name))]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "FormItem",
                { attrs: { label: "", prop: "channel_id" } },
                [
                  _c(
                    "Select",
                    {
                      staticStyle: { width: "90%" },
                      attrs: { filterable: "", placeholder: "请选择渠道" },
                      model: {
                        value: _vm.addChannelForm.channel_id,
                        callback: function($$v) {
                          _vm.$set(_vm.addChannelForm, "channel_id", $$v)
                        },
                        expression: "addChannelForm.channel_id"
                      }
                    },
                    _vm._l(_vm.channelAddList, function(item) {
                      return _c(
                        "Option",
                        { key: item.id, attrs: { value: item.id } },
                        [_vm._v(_vm._s(item.name))]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "FormItem",
                { attrs: { label: "渠道说明" } },
                [
                  _c("Input", {
                    staticStyle: { width: "90%" },
                    attrs: {
                      type: "textarea",
                      autosize: { minRows: 2, maxRows: 5 },
                      maxlength: 100,
                      placeholder: "请在100字内描述特有的渠道说明"
                    },
                    model: {
                      value: _vm.addChannelForm.channel_explain,
                      callback: function($$v) {
                        _vm.$set(_vm.addChannelForm, "channel_explain", $$v)
                      },
                      expression: "addChannelForm.channel_explain"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "FormItem",
                { attrs: { label: "备注", prop: "remark" } },
                [
                  _c("Input", {
                    staticStyle: { width: "90%" },
                    attrs: {
                      type: "textarea",
                      autosize: { minRows: 2, maxRows: 5 },
                      placeholder: "请在200字内描述增加渠道的原因"
                    },
                    model: {
                      value: _vm.addChannelForm.remark,
                      callback: function($$v) {
                        _vm.$set(_vm.addChannelForm, "remark", $$v)
                      },
                      expression: "addChannelForm.remark"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "Button",
                {
                  attrs: { type: "primary", size: "large" },
                  on: {
                    click: function($event) {
                      return _vm.handleSubmit("addChannelForm")
                    }
                  }
                },
                [_vm._v("确定")]
              ),
              _vm._v(" "),
              _c(
                "Button",
                {
                  attrs: { size: "large" },
                  on: {
                    click: function($event) {
                      return _vm.handleReset("addChannelForm")
                    }
                  }
                },
                [_vm._v("取消")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Modal",
        {
          attrs: {
            closable: false,
            "mask-closable": false,
            "class-name": "vertical-center-modal"
          },
          model: {
            value: _vm.showAddStores,
            callback: function($$v) {
              _vm.showAddStores = $$v
            },
            expression: "showAddStores"
          }
        },
        [
          _c(
            "p",
            {
              staticClass: "modal_title",
              attrs: { slot: "header" },
              slot: "header"
            },
            [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.isModalTitle == 3
                      ? "添加跟进门店"
                      : _vm.isModalTitle == 4
                      ? "编辑跟进门店"
                      : ""
                  )
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "Form",
            {
              ref: "addStoresForm",
              attrs: {
                model: _vm.addStoresForm,
                rules: _vm.addStoresFormRule,
                "label-width": 80
              }
            },
            [
              _c(
                "FormItem",
                { attrs: { label: "跟进门店", prop: "follow_store_id" } },
                [
                  _c(
                    "Select",
                    {
                      staticStyle: { width: "90%" },
                      attrs: {
                        disabled: _vm.isModalTitle == 4 ? true : false,
                        placeholder: "请选择门店"
                      },
                      model: {
                        value: _vm.addStoresForm.follow_store_id,
                        callback: function($$v) {
                          _vm.$set(_vm.addStoresForm, "follow_store_id", $$v)
                        },
                        expression: "addStoresForm.follow_store_id"
                      }
                    },
                    _vm._l(_vm.storeList, function(item) {
                      return _c(
                        "Option",
                        { key: item.id, attrs: { value: item.id } },
                        [_vm._v(_vm._s(item.name))]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "FormItem",
                { attrs: { label: "客户分组", prop: "follow_group_id" } },
                [
                  _c(
                    "Select",
                    {
                      staticStyle: { width: "90%" },
                      attrs: { placeholder: "请选择分组" },
                      model: {
                        value: _vm.addStoresForm.follow_group_id,
                        callback: function($$v) {
                          _vm.$set(_vm.addStoresForm, "follow_group_id", $$v)
                        },
                        expression: "addStoresForm.follow_group_id"
                      }
                    },
                    _vm._l(_vm.customerGroudList, function(item) {
                      return _c(
                        "Option",
                        { key: item.id, attrs: { value: item.id } },
                        [_vm._v(_vm._s(item.name))]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "FormItem",
                { attrs: { label: "跟进结果", prop: "come_status" } },
                [
                  _c(
                    "Select",
                    {
                      staticStyle: { width: "90%" },
                      attrs: {
                        disabled: _vm.comeStatus,
                        placeholder: "请选择是否已到店"
                      },
                      model: {
                        value: _vm.addStoresForm.come_status,
                        callback: function($$v) {
                          _vm.$set(_vm.addStoresForm, "come_status", $$v)
                        },
                        expression: "addStoresForm.come_status"
                      }
                    },
                    _vm._l(_vm.baseData.come_status, function(item) {
                      return _c(
                        "Option",
                        { key: item.id, attrs: { value: item.id } },
                        [_vm._v(_vm._s(item.name))]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.addStoresForm.come_status == "2"
                ? _c(
                    "FormItem",
                    { attrs: { label: "到店方式", prop: "come_id" } },
                    [
                      _c(
                        "Select",
                        {
                          staticStyle: { width: "90%" },
                          attrs: { placeholder: "请选择到店方式" },
                          model: {
                            value: _vm.addStoresForm.come_id,
                            callback: function($$v) {
                              _vm.$set(_vm.addStoresForm, "come_id", $$v)
                            },
                            expression: "addStoresForm.come_id"
                          }
                        },
                        _vm._l(_vm.returnSettingList, function(item) {
                          return _c(
                            "Option",
                            { key: item.id, attrs: { value: item.id } },
                            [_vm._v(_vm._s(item.return_info))]
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.addStoresForm.come_status == "2"
                ? _c(
                    "FormItem",
                    {
                      staticStyle: { width: "90%" },
                      attrs: { label: "到店时间", prop: "come_date" }
                    },
                    [
                      _c("DatePicker", {
                        staticStyle: { display: "block" },
                        attrs: { format: "yyyy-MM-dd", placeholder: "请选择" },
                        model: {
                          value: _vm.addStoresForm.come_date,
                          callback: function($$v) {
                            _vm.$set(_vm.addStoresForm, "come_date", $$v)
                          },
                          expression: "addStoresForm.come_date"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.addStoresForm.come_status == "2"
                ? _c(
                    "FormItem",
                    {
                      staticStyle: { width: "90%" },
                      attrs: { label: "到店结果", prop: "arrival_result_id" }
                    },
                    [
                      _vm.addStoresForm.come_status == "2"
                        ? _c(
                            "Select",
                            {
                              attrs: { placeholder: "到店结果" },
                              model: {
                                value: _vm.addStoresForm.arrival_result_id,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.addStoresForm,
                                    "arrival_result_id",
                                    $$v
                                  )
                                },
                                expression: "addStoresForm.arrival_result_id"
                              }
                            },
                            _vm._l(_vm.arrival_result, function(item) {
                              return _c(
                                "Option",
                                {
                                  key: item["id"].toString(),
                                  attrs: { value: item["id"].toString() }
                                },
                                [_vm._v(_vm._s(item["result"]))]
                              )
                            }),
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.addStoresForm.arrival_result_id == "0"
                ? _c(
                    "FormItem",
                    { attrs: { label: "到店结果", prop: "arrival_result_id" } },
                    [
                      _c("Input", {
                        attrs: { maxlength: 20, placeholder: "1-12个字符" },
                        model: {
                          value: _vm.addStoresForm.other,
                          callback: function($$v) {
                            _vm.$set(_vm.addStoresForm, "other", $$v)
                          },
                          expression: "addStoresForm.other"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "Button",
                {
                  attrs: { type: "primary", size: "large" },
                  on: {
                    click: function($event) {
                      return _vm.handleSubmit("addStoresForm")
                    }
                  }
                },
                [_vm._v("确定")]
              ),
              _vm._v(" "),
              _c(
                "Button",
                {
                  attrs: { size: "large" },
                  on: {
                    click: function($event) {
                      return _vm.handleReset("addStoresForm")
                    }
                  }
                },
                [_vm._v("取消")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Modal",
        {
          attrs: {
            closable: false,
            styles: _vm.stylesModal,
            "mask-closable": false,
            "class-name": "vertical-center-modal"
          },
          model: {
            value: _vm.showAddMaternal,
            callback: function($$v) {
              _vm.showAddMaternal = $$v
            },
            expression: "showAddMaternal"
          }
        },
        [
          _c(
            "p",
            {
              staticClass: "modal_title",
              attrs: { slot: "header" },
              slot: "header"
            },
            [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.isModalTitle == 5
                      ? "添加产妇信息"
                      : _vm.isModalTitle == 6
                      ? "编辑产妇信息"
                      : ""
                  )
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "Form",
            {
              ref: "addMaternalForm",
              staticStyle: { width: "100%", height: "340px", overflow: "auto" },
              attrs: {
                model: _vm.addMaternalForm,
                rules: _vm.addMaternalFormRule,
                "label-width": 80
              }
            },
            [
              _c(
                "FormItem",
                { attrs: { label: "预产期", prop: "child_birth" } },
                [
                  _c("DatePicker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "date",
                      placeholder: "请选择预产期",
                      value: _vm.addMaternalForm.child_birth
                    },
                    on: { "on-change": _vm.changeChild_birth }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "FormItem",
                { attrs: { label: "分娩医院" } },
                [
                  _c(
                    "Select",
                    {
                      attrs: {
                        filterable: "",
                        remote: "",
                        clearable: "",
                        "remote-method": _vm.remoteMethod1,
                        loading: _vm.remoteLoading
                      },
                      on: { "on-query-change": _vm.remoteMethod },
                      model: {
                        value: _vm.addMaternalForm.hospital,
                        callback: function($$v) {
                          _vm.$set(_vm.addMaternalForm, "hospital", $$v)
                        },
                        expression: "addMaternalForm.hospital"
                      }
                    },
                    _vm._l(_vm.hospitalList, function(option, index) {
                      return _c(
                        "Option",
                        {
                          key: index,
                          attrs: { value: option.label, label: option.label }
                        },
                        [
                          _c("span", [_vm._v(_vm._s(option.label))]),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticStyle: { float: "right", color: "#ccc" } },
                            [_vm._v(_vm._s(option.value))]
                          )
                        ]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "FormItem",
                { attrs: { label: "家属信息" } },
                [
                  _c(
                    "Button",
                    {
                      staticStyle: { width: "100px" },
                      attrs: { type: "primary", long: "", icon: "md-add" },
                      on: { click: _vm.addFamily }
                    },
                    [_vm._v("添加")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.addMaternalForm.maternal_family, function(
                item,
                index
              ) {
                return _c(
                  "FormItem",
                  {
                    key: index,
                    attrs: {
                      label: "家属信息",
                      prop: "maternal_family." + index + ".name",
                      rules: {
                        required: true,
                        message: "家属姓名不能为空",
                        trigger: "blur"
                      }
                    }
                  },
                  [
                    _c("Input", {
                      attrs: { type: "text", placeholder: "请输入家属姓名" },
                      model: {
                        value: item.name,
                        callback: function($$v) {
                          _vm.$set(item, "name", $$v)
                        },
                        expression: "item.name"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "Select",
                      {
                        staticClass: "mr-t-10",
                        attrs: { placeholder: "请选择家属关系" },
                        model: {
                          value: item.relation,
                          callback: function($$v) {
                            _vm.$set(item, "relation", $$v)
                          },
                          expression: "item.relation"
                        }
                      },
                      [
                        _c("Option", { attrs: { value: "夫妻" } }, [
                          _vm._v("夫妻")
                        ]),
                        _vm._v(" "),
                        _c("Option", { attrs: { value: "男方家属" } }, [
                          _vm._v("男方家属")
                        ]),
                        _vm._v(" "),
                        _c("Option", { attrs: { value: "女方家属" } }, [
                          _vm._v("女方家属")
                        ]),
                        _vm._v(" "),
                        _c("Option", { attrs: { value: "其他" } }, [
                          _vm._v("其他")
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("Input", {
                      staticClass: "mr-t-10",
                      attrs: {
                        type: "text",
                        maxlength: 11,
                        placeholder: "请输入家属联系方式"
                      },
                      model: {
                        value: item.phone,
                        callback: function($$v) {
                          _vm.$set(item, "phone", $$v)
                        },
                        expression: "item.phone"
                      }
                    }),
                    _vm._v(" "),
                    _c("Input", {
                      staticClass: "mr-t-10",
                      attrs: { type: "text", placeholder: "请输入身份证号" },
                      model: {
                        value: item.id_card,
                        callback: function($$v) {
                          _vm.$set(item, "id_card", $$v)
                        },
                        expression: "item.id_card"
                      }
                    }),
                    _vm._v(" "),
                    _c("Input", {
                      staticClass: "mr-t-10",
                      attrs: { type: "text", placeholder: "请输入联系地址" },
                      model: {
                        value: item.address,
                        callback: function($$v) {
                          _vm.$set(item, "address", $$v)
                        },
                        expression: "item.address"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "Button",
                      {
                        staticClass: "mr-t-10",
                        attrs: { type: "error" },
                        on: {
                          click: function($event) {
                            return _vm.removeFamily(index)
                          }
                        }
                      },
                      [_vm._v("删除")]
                    )
                  ],
                  1
                )
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "Button",
                {
                  attrs: { type: "primary", size: "large" },
                  on: {
                    click: function($event) {
                      return _vm.handleSubmit("addMaternalForm")
                    }
                  }
                },
                [_vm._v("确定")]
              ),
              _vm._v(" "),
              _c(
                "Button",
                {
                  attrs: { size: "large" },
                  on: {
                    click: function($event) {
                      return _vm.handleReset("addMaternalForm")
                    }
                  }
                },
                [_vm._v("取消")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Modal",
        {
          attrs: {
            closable: false,
            styles: _vm.stylesModal,
            scrollable: true,
            "mask-closable": false,
            "class-name": "vertical-center-modal"
          },
          model: {
            value: _vm.showAddWithPeople,
            callback: function($$v) {
              _vm.showAddWithPeople = $$v
            },
            expression: "showAddWithPeople"
          }
        },
        [
          _c(
            "p",
            {
              staticClass: "modal_title",
              attrs: { slot: "header" },
              slot: "header"
            },
            [_c("span", [_vm._v("添加跟进人")])]
          ),
          _vm._v(" "),
          _c(
            "Form",
            {
              ref: "addWithPeopleForm",
              staticStyle: { width: "70%" },
              attrs: {
                model: _vm.addWithPeopleForm,
                rules: _vm.addWithPeopleFormRule,
                "label-width": 80
              }
            },
            [
              _c(
                "FormItem",
                { attrs: { label: "门店", prop: "store_id" } },
                [
                  _c(
                    "Select",
                    {
                      attrs: { placeholder: "请选择门店" },
                      on: { "on-change": _vm.changeAddDepartment },
                      model: {
                        value: _vm.addWithPeopleForm.store_id,
                        callback: function($$v) {
                          _vm.$set(_vm.addWithPeopleForm, "store_id", $$v)
                        },
                        expression: "addWithPeopleForm.store_id"
                      }
                    },
                    _vm._l(_vm.tabStoresData, function(item) {
                      return _c(
                        "Option",
                        {
                          key: item.id,
                          attrs: { value: item.follow_store_id }
                        },
                        [_vm._v(_vm._s(item.follow_store_name))]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "FormItem",
                { attrs: { label: "部门", prop: "department_id" } },
                [
                  _c(
                    "Select",
                    {
                      attrs: { placeholder: "请选择部门" },
                      on: { "on-change": _vm.changeAddFollowr },
                      model: {
                        value: _vm.addWithPeopleForm.department_id,
                        callback: function($$v) {
                          _vm.$set(_vm.addWithPeopleForm, "department_id", $$v)
                        },
                        expression: "addWithPeopleForm.department_id"
                      }
                    },
                    _vm._l(_vm.followDepartmentList, function(item) {
                      return _c(
                        "Option",
                        { key: item.id, attrs: { value: item.id } },
                        [_vm._v(_vm._s(item.name))]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "FormItem",
                { attrs: { label: "跟进人", prop: "follow_user" } },
                [
                  _c(
                    "Select",
                    {
                      attrs: { placeholder: "请选择跟进人" },
                      model: {
                        value: _vm.addWithPeopleForm.follow_user,
                        callback: function($$v) {
                          _vm.$set(_vm.addWithPeopleForm, "follow_user", $$v)
                        },
                        expression: "addWithPeopleForm.follow_user"
                      }
                    },
                    _vm._l(_vm.followrAddList, function(item) {
                      return _c(
                        "Option",
                        { key: item.id, attrs: { value: item.id } },
                        [_vm._v(_vm._s(item.user_name))]
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "Button",
                {
                  attrs: { type: "primary", size: "large" },
                  on: {
                    click: function($event) {
                      return _vm.handleSubmit("addWithPeopleForm")
                    }
                  }
                },
                [_vm._v("确定")]
              ),
              _vm._v(" "),
              _c(
                "Button",
                {
                  attrs: { size: "large" },
                  on: {
                    click: function($event) {
                      return _vm.handleReset("addWithPeopleForm")
                    }
                  }
                },
                [_vm._v("取消")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-af4ced3e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af4ced3e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/commonTmp/CRM/CustomerManagementTmp/userDetails.vue
// module id = null
// module chunks = 